import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconBlockUser.module.css';

const IconBlockUser = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 3.75C7.55558 3.75 3.75 7.55558 3.75 12.25C3.75 16.9444 7.55558 20.75 12.25 20.75C16.9444 20.75 20.75 16.9444 20.75 12.25C20.75 7.55558 16.9444 3.75 12.25 3.75ZM2.25 12.25C2.25 6.72715 6.72715 2.25 12.25 2.25C17.7728 2.25 22.25 6.72715 22.25 12.25C22.25 17.7728 17.7728 22.25 12.25 22.25C6.72715 22.25 2.25 17.7728 2.25 12.25Z"
        fill="#656566"
      />
      <path
        d="M18.2604 5.17898L19.3211 6.23964L6.23962 19.3211L5.17896 18.2605L18.2604 5.17898Z"
        fill="#656566"
      />
    </svg>
  );
};

IconBlockUser.defaultProps = { className: null };

IconBlockUser.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconBlockUser;
